var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalEvRoadAssitance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.282,
    height: 30.815,
    viewBox: "0 0 32.282 30.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_EV_Road_Assitance",
    "data-name": "Total EV Road Assitance",
    transform: "translate(-390.089 -457.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    transform: "translate(390.089 457.964)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.282,
    height: 30.815,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31.282,
    height: 29.815,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-car-repair-4628177",
    transform: "translate(410.589 483.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1",
    "data-name": "Ebene 1",
    transform: "translate(-23.272 -30.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M25.859,75H10.371a.381.381,0,1,0,0,.762H25.859a.381.381,0,0,0,0-.762Z",
    transform: "translate(0 -47.75)",
    fill: "#00b26b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M79.869,75h-.508a.381.381,0,0,0,0,.762h.508a.381.381,0,0,0,0-.762Z",
    transform: "translate(-51.473 -47.75)",
    fill: "#00b26b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M19,64.777a.508.508,0,0,0,.508.508h1.27a.508.508,0,0,0,.508-.508V63H19Z",
    transform: "translate(-6.722 -38.797)",
    fill: "#00b26b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M57,64.777a.508.508,0,0,0,.508.508h1.27a.508.508,0,0,0,.508-.508V63H57Z",
    transform: "translate(-35.074 -38.797)",
    fill: "#00b26b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M67.793,11a2.793,2.793,0,1,0,2.793,2.793A2.793,2.793,0,0,0,67.793,11ZM67.4,14.839a.632.632,0,0,1-.881.521l.376-.376-.343-.343-.373.371a.634.634,0,1,1,1.221-.188.015.015,0,0,1,0,.015Zm1.991.19-.378-.376L68.674,15l.373.371a.635.635,0,0,1-.868-.627.627.627,0,0,1,.185-.411.617.617,0,0,1,.508-.183h0a.625.625,0,0,1,.388.183.637.637,0,0,1,.135.7Zm-.132-1.843a.635.635,0,0,1-.429.185.579.579,0,0,1-.226-.036l-.421.421.211.211-.4.4-.206-.211-.206.206-.4-.4.206-.206-.419-.419a.554.554,0,0,1-.213.033.625.625,0,0,1-.434-.185.637.637,0,0,1-.137-.7l.416.416h.335v-.335l-.414-.421a.64.64,0,0,1,.691.137.632.632,0,0,1,.183.429.569.569,0,0,1-.033.226l.429.416.424-.424a.6.6,0,0,1-.033-.211.632.632,0,0,1,.879-.571l-.416.414V12.9h.335l.414-.414a.632.632,0,0,1-.132.7Z",
    transform: "translate(-41.043)",
    fill: "#00b26b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M13.032,34.141H26.1a1.465,1.465,0,0,0,1.465-1.465V31.03A1.463,1.463,0,0,0,26.1,29.57h-.107l-1.62-3.717A1.424,1.424,0,0,0,23.062,25h-6.7a1.432,1.432,0,0,0-1.308.856L13.426,29.57h-.394a1.463,1.463,0,0,0-1.462,1.463v1.643a1.465,1.465,0,0,0,1.463,1.465Zm4.631-1.523h0a.254.254,0,0,1-.254-.254V31.348a.254.254,0,0,1,.254-.254h0a.254.254,0,0,1,.254.254v1.016A.254.254,0,0,1,17.664,32.617Zm1.27,0h0a.254.254,0,0,1-.254-.254V31.348a.254.254,0,0,1,.254-.254h0a.254.254,0,0,1,.254.254v1.016A.254.254,0,0,1,18.933,32.617Zm1.27,0h0a.254.254,0,0,1-.254-.254V31.348a.254.254,0,0,1,.254-.254h0a.254.254,0,0,1,.254.254v1.016A.254.254,0,0,1,20.2,32.617Zm1.27,0h0a.254.254,0,0,1-.254-.254V31.348a.254.254,0,0,1,.254-.254h0a.254.254,0,0,1,.254.254v1.016A.254.254,0,0,1,21.472,32.617ZM15.97,26.9c.236-.541.475-.889,1.061-.889H22.2c.589,0,.825.348,1.059.889L24.43,29.57H14.8Zm-1.861,4.192h1.016v1.523H14.109a.762.762,0,0,1-.762-.762h0A.762.762,0,0,1,14.109,31.094Zm10.918,1.523H24.011V31.094h1.016a.762.762,0,0,1,.762.762h0a.762.762,0,0,1-.762.762Z",
    transform: "translate(-1.179 -10.445)",
    fill: "#00b26b",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalEvRoadAssitance);
export default __webpack_public_path__ + "static/media/Total EV Road Assitance.a7eeebef3e1ed11f414e9fa5a5bbbfd7.svg";
export { ForwardRef as ReactComponent };